import React from "react";
import { Link, Outlet } from "react-router-dom";

const AdminPanel = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <nav
        style={{
          width: "250px",
          background: "#343a40",
          color: "#fff",
          padding: "20px 10px",
        }}
      >
        <h2 style={{ color: "#ffc107", textAlign: "center" }}>Admin Panel</h2>
        <ul style={{ listStyleType: "none", padding: 0, marginTop: "20px" }}>
        <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/super-dashboard"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              ALL
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/dashboard"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Dashboard
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/rentals"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Rentals
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/cars"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Cars Management
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/edit-car-details"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Car editing
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/users"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Users Management
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/background"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Background
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/approvals"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Approvals
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/edit-car-details"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Car editing
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/transactions"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Transactions
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/payments"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Payments
            </Link>
          </li>
          {/* New link for Payout Car */}
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/payout-car"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Payout Car
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/random-car-generator"
              style={{ color: "#fff", textDecoration: "none" }}
            >
             Car Generator
            </Link>
          </li>
          <li style={{ margin: "15px 0" }}>
            <Link
              to="/admin/admin-feedback"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              Feedback
            </Link>
          </li>
        </ul>
      </nav>

      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px" }}>
        <Outlet />
      </div>
    </div>
  );
};

export default AdminPanel;
